/**
 * Spellcasting trial targets from `src/pages/images/shooting/`.
 * f1–f3: friendly; h1–h10: dark.
 */
import f1 from "../images/shooting/f1.png";
import f2 from "../images/shooting/f2.png";
import f3 from "../images/shooting/f3.png";
import f4 from "../images/shooting/f4.png";
import f5 from "../images/shooting/f5.png";
import f6 from "../images/shooting/f6.png";
import h1 from "../images/shooting/h1.png";
import h2 from "../images/shooting/h2.png";
import h3 from "../images/shooting/h3.png";
import h4 from "../images/shooting/h4.png";
import h5 from "../images/shooting/h5.png";
import h6 from "../images/shooting/h6.png";
import h7 from "../images/shooting/h7.png";


/** @typedef {'hedwig'|'snitch'|'hogwarts_student'|'creature'|'generic'} TargetFlavor */

/**
 * @typedef {{ src: string, id: string, flavor?: TargetFlavor }} SpellTargetDef
 */

/** @type {SpellTargetDef[]} */
export const DARK_TARGETS = [
  { id: "dark_h1", src: h1 },
  { id: "dark_h2", src: h2 },
  { id: "dark_h3", src: h3 },
  { id: "dark_h4", src: h4 },
  { id: "dark_h5", src: h5 },
  { id: "dark_h6", src: h6 },
  { id: "dark_h7", src: h7 },
 
];

/** @type {SpellTargetDef[]} */
export const FRIENDLY_TARGETS = [
  { id: "friendly_f1", src: f1, flavor: "hedwig" },
  { id: "friendly_f2", src: f2, flavor: "creature" },
  { id: "friendly_f3", src: f3, flavor: "hogwarts_student" },
  { id: "friendly_f4", src: f4, flavor: "hogwarts_student" },
  { id: "friendly_f5", src: f5, flavor: "hogwarts_student" },
  { id: "friendly_f6", src: f6, flavor: "hogwarts_student" },
];
